import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetVatReportResponse } from '@/api/handlers/resources/vat/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { VatQueryKeys } from './vatQueryKeys';

const STALE_TIME_MS = 5 * 60_000;

/**
 * VAT movement over a period. Keyed on the range and `locale`, so changing the
 * range (or a preset, or the language) refetches; `keepPreviousData` keeps the
 * prior report on screen while the new range loads.
 */
export const useVatReportQuery = (
    fromDate: string,
    toDate: string,
    locale: string,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetVatReportResponse>>({
        queryKey: VatQueryKeys.report(fromDate, toDate, locale),
        queryFn: () => apiClient.vat.getVatReport(fromDate, toDate, { locale }),
        enabled: fromDate.length > 0 && toDate.length > 0,
        staleTime: STALE_TIME_MS,
        placeholderData: keepPreviousData,
    });
};
